import React, { useState } from "react";
import bankContext from "./bankContext";
import API_BASE from "../../apiConfig";

const BankState = (props) => {
    const host = API_BASE;

    const emptyBank = {
        bankName: "",
        branchName: "",
        accountNumber: "",
        ifscCode: "",
        upiId: ""   
    };

    const [bank, setBank] = useState(emptyBank);

    const getBankDetails = async () => {
        try {
            const response = await fetch(`${host}/api/bank/getbankdetails`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "auth-token": localStorage.getItem("token")
                }
            });

            const json = await response.json();

            if (json && Object.keys(json).length > 0) {
                setBank({
                    bankName: json.bankName || "",
                    branchName: json.branchName || "",
                    accountNumber: json.accountNumber || "",
                    ifscCode: json.ifscCode || "",
                    upiId: json.upiId || ""   
                });
            } else {
                setBank(emptyBank);
            }
        } catch (error) {
            console.error("Error fetching bank details:", error);
            setBank(emptyBank);
        }
    };

    return (
        <bankContext.Provider value={{ bank, setBank, getBankDetails }}>
            {props.children}
        </bankContext.Provider>
    );
}

export default BankState;